import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import NavBar from "../NavBar/NavBar.tsx";
import Footer from "../Footer/Footer.tsx";
import OurCeo from "../Our Ceo/OurCeo.tsx";
import OurApproach from "../Our Approach/OurApproach.tsx";
import OurServicesSection from "../OurServicesSection/OurServicesSection.tsx";
import OurValues from "../Our Values/OurValues.tsx";
import CompanySlider from "../CompanySlider/CompanySlider.tsx";
import OurProducts from "../Products/OurProducts.tsx";
import HeroBanner from "../HeroBanner/HeroBanner.tsx";
import WhoWeAre from "../WhoWeAre/WhoWeAre.tsx";
import ScrollToTopButton from "../Common-component/ScrollToTopButton.tsx";
import SiteSidebar from "../SiteSidebar.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".OurValues1", {
        opacity: 0,
        duration: 2,
        x: -500,
        scrollTrigger: {
          trigger: ".OurValues1",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
      gsap.from(".OurService1", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".OurService1",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
      gsap.from(".Approach1", {
        opacity: 0,
        duration: 2,
        x: -500,
        scrollTrigger: {
          trigger: ".Approach1",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
      gsap.from(".OurTestinomials1", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".OurTestinomials1",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });

  useGSAP(() => {
    gsap.from(".gsapHomeBanner", {
      y: -30,
      opacity: 0,
      duration: 1,
      delay: 1,
    });
  });

  return (
    <div>
      <NavBar />

      {/* hero banner */}
      <HeroBanner />

      {/* who we are */}
      <WhoWeAre />

      {/* Our Values */}
      <OurValues />

      {/* Our services */}
      <Box style={{ height: "auto", width: "100%" }} className="OurService1">
        <Box>
          <OurServicesSection />
        </Box>
      </Box>

      <OurApproach />
      <OurProducts />
      <OurCeo />
      <CompanySlider />
      <Footer />
      <ScrollToTopButton />
      <SiteSidebar />
    </div>
  );
};

export default HomePage;